/**
 * TanStack Query hooks for `email-in-app-webhook-notification-channels`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	emailInAppWebhookNotificationChannelsQueryKeys,
	type CreateEmailInAppWebhookNotificationChannelsBody,
	type ListEmailInAppWebhookNotificationChannelsResponse,
	type EmailInAppWebhookNotificationChannelsRow,
} from "./api";

export function useEmailInAppWebhookNotificationChannelsList(): UseQueryResult<ListEmailInAppWebhookNotificationChannelsResponse, Error> {
	return useQuery({
		queryKey: emailInAppWebhookNotificationChannelsQueryKeys.list(),
		queryFn: list,
	});
}

export function useEmailInAppWebhookNotificationChannelsCreate(): UseMutationResult<EmailInAppWebhookNotificationChannelsRow, Error, CreateEmailInAppWebhookNotificationChannelsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: emailInAppWebhookNotificationChannelsQueryKeys.all });
		},
	});
}

export function useEmailInAppWebhookNotificationChannelsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: emailInAppWebhookNotificationChannelsQueryKeys.all });
		},
	});
}
